import { fetchLocations, selectLocationPlaces, selectLocationStatus } from 'containers/Maps/Result/locationSlice'
import NewPlaceElementForList from 'containers/Maps/Result/NewPlaceElementForList'
import PlaceElementForList from 'containers/Maps/Result/PlaceElementForList'
import WarehouseAttrPopup from 'containers/Maps/Popups/WarehouseAttrPopup'
import AnnouncementPopup from 'containers/Maps/Popups/AnnouncementPopup'
import AutomationPopup from 'containers/Maps/Popups/AutomationPopup'
import SkeletonElement from 'containers/Maps/Result/SkeletonElement'
import { ReactComponent as Forward } from 'assets/forwardBtn.svg'
import { selectIsLoggedIn } from 'containers/Login/loginSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { LOCATION_STATES, STATUS } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import Categories from 'containers/Categories'
import { useHistory } from 'react-router-dom'
import OnePage from 'containers/OnePage'
import Error from 'components/Error'
import { useEffect } from 'react'
import './style.scss'

export const POPUPS = {
  magMobile: 'magMobile',
  magStore: 'magStore',
  invest: 'invest',
}

const type = process.env.REACT_APP_TYPE
const skeletonList = (type === 'chr01' || type === 'ldz01') ? [1] : type === 'demo' ? [1, 2, 3] : [1, 2]

const Home = ({ showOptionalCategories = false }) => {
  const isLoggedIn = useReduxSelector(selectIsLoggedIn)
  const { push } = useHistory()
  const { t } = useTranslation('home')
  const showPopup = p => {
    push(window.location.pathname, LOCATION_STATES.popup(p))
  }

  if (type === 'box') {
    return (showOptionalCategories && isLoggedIn)
      ? <Categories />
      : <OnePage />
  }

  if (type !== 'mm' && type !== 'box') {
    return (
      <div className='home'>
        <div className='title'>
          <div>{t('rentAWarehouse')}</div>
          <div>{t('selectLocations')}</div>
        </div>
        <PlacesList />
      </div>
    )
  }

  return (
    <div className='home'>
      <div className='title'>
        <div>{t('yourMove')}</div>
        <div>{t('whatDoYouWantToDo')}</div>
      </div>

      <div className='list'>
        {type === 'mm' && <div className='list__element --big'
          onClick={() => {
            showPopup(POPUPS.magStore)
          }}>
          <div className='element__group group'>
            <i className='icon icon--magStorage-bold s32' />
            <i className='icon icon--dots' />
          </div>
          <div>
            <div className='element__title --secFont'>MagStore</div>
            <div className='element__text'>{t('sendUsYourItemsForStorage')}</div>
          </div>
          <div className='element__back'>
            <Forward />
          </div>
        </div>}

        {type === 'mm' && <div
          className='list__element'
          onClick={() => showPopup(POPUPS.magMobile)}>
          <div className='element__group group'>
            <i className='icon icon--magMobile s32' />
            <i className='icon icon--dots' />
          </div>
          <div>
            <div className='element__title --secFont'>MagMobile</div>
            <div className='element__text'>{t('orderAMobileWarehouse')}</div>
          </div>
          <div className='element__back'>
            <Forward />
          </div>
        </div>}

        <div
          className='list__element --black'
          onClick={() => {
            push('/categories')
          }}>
          <i className='icon icon--logo s24 cWhite' />
          <div>
            <div className='element__title --secFont'>
              <div>{t('rent')}</div>
              <div>{t('warehouse')}</div>
            </div>
          </div>
          <div className='element__text'>Self-Storage</div>
        </div>

        <div
          className='list__element'
          onClick={() => {
            showPopup(POPUPS.invest)
          }}>
          <div className='element__group group'>
            <i className='icon icon--community s32' />
            <i className='icon icon--dots' />
          </div>
          <div className='element__title --secFont'>
            <div>{t('invest')}</div>
            <div>{t('inUs')}</div>
          </div>
          <div className='element__back'>
            <Forward />
          </div>
        </div>

        {type === 'mm' && <div
          className='list__element'
          onClick={() => {
            push('/shop')
          }}>
          <div className='element__group group'>
            <i className='icon icon--shopping-bag-bold s32' />
            <i className='icon icon--dots' />
          </div>
          <div>
            <div className='element__title --secFont'>MagShop</div>
            <div className='element__text'>{t('buyTheNecessaryAccessories')}</div>
          </div>
          <div className='element__back'>
            <Forward />
          </div>
        </div>}
      </div>
    </div>
  )
}

const PlacesList = () => {
  const placesStatus = useReduxSelector(selectLocationStatus)
  const places = useReduxSelector(selectLocationPlaces)
  const { popup } = usePopupState()

  const { t } = useTranslation('home')
  const dispatch = useReduxDispatch()
  useEffect(() => {
    if (placesStatus !== STATUS.pending) {
      dispatch(fetchLocations({}))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  return (
    <>
      {popup?.type === 'warehouse_attr' && popup?.place_attrs && <WarehouseAttrPopup body={popup?.place_attrs} />}
      {popup?.type === 'automation' && popup?.automation && <AutomationPopup body={popup?.automation} />}
      {popup?.type === 'announcement' && <AnnouncementPopup placeId={popup.placeId} />}
      <div className='home__placeList'>
        {Array.isArray(places) && places.length > 0
          ? <div className='resultList'>
            {places.map((place) => type === 'rze01'
              ? <PlaceElementForList
                isDesktop
                showButton
                data={place}
                key={place.id}
                customRedirect={`/mapdetails/${place.id}`}
              />
              : <NewPlaceElementForList
                data={place}
                key={place.id}
                customRedirect={`/mapdetails/${place.id}`}
              />)}
          </div>
          : placesStatus !== STATUS.succeed
            ? <div className='resultList'>
              {skeletonList.map((index) => <SkeletonElement
                isDesktop
                key={index}
              />)}
            </div>
            : <Error text={t('thereIsALackOfYards')} />}
      </div>
    </>
  )
}

export default Home